var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"color/all",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z","stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }